import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

/** Signed into Firebase, but not on the dogfood allowlist. */
export function NotYetPage() {
  const { user, loading, signOutUser } = useAuth()

  if (!loading && !user) return <Navigate to="/login" replace />

  return (
    <div className="shell login-shell">
      <header className="top compact">
        <div className="brand">
          <span className="mark">BeyondQuota</span>
          <h1>Not on the inside yet</h1>
        </div>
      </header>

      <div className="login-card">
        <p className="lede tight">
          You signed in fine, but this workspace is invite-only right now
          (open signup is off). Ask an operator to add your email to the
          allowlist, then sign in again.
        </p>
        {user?.email && (
          <p className="muted">
            Signed in as <span className="auth-email">{user.email}</span>
          </p>
        )}
        <button
          type="button"
          className="login-secondary"
          onClick={() => void signOutUser()}
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
